import styled from "styled-components";
import { DARK_GRAY } from "@shape/reef-shared";

export const Container = styled.div<{ box: boolean }>`
  background-color: ${({ box }) => (box ? `${DARK_GRAY}` : ``)};
  padding: ${({ box }) => (box ? "15px" : `0px`)};
  border-radius: 4px;
`;
